<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title">
        Промокоды
      </h4>

      <div class="promo__items">
        <div
          v-for="(promo, index) in localPromoCodes"
          :key="'promo' + index"
          class="promo__item"
        >
          <div
            class="promo__item-del"
            role="button"
            tabindex="0"
            @click="removePromo(promo, index)"
          >
            <svg
              width="10"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
              />
            </svg>
          </div>

          <b-form-input
            v-model="promo.code"
            placeholder="Код"
            class="inline-block mb-1"
          />
          <b-form-checkbox
            :checked="promo.percent === false"
            switch
            class="custom-control-primary mb-1"
            @change="value => changeDiscountType(promo, value)"
          >
            Скидка в рублях
          </b-form-checkbox>
          <b-form-input
            v-if="promo.percent !== false"
            v-model.number="promo.value"
            type="number"
            no-wheel
            placeholder="Скидка в %"
            class="inline-block mb-1"
          />
          <price-input-wrapper
            v-else
            :value="promo.value"
            placeholder="Скидка в рублях"
            class="mb-1"
            @input="value => (promo.value = value)"
          />
          <flat-pickr
            v-model="promo.expiresAt"
            placeholder="Срок действия"
            class="form-control inline-block mb-1"
            :config="dateConfig"
          />
          <b-form-input
            v-model.number="promo.usageLimitInitial"
            type="number"
            no-wheel
            placeholder="Лимит использований"
            class="inline-block"
          />
          <span
            v-if="promo.usageLimitInitial"
            class="mt-1 d-block text-muted small"
          >Доступно {{ promo.usageAvailable || 0 }} из
            {{ promo.usageLimitInitial }}</span>
        </div>
      </div>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mr-1 mt-1"
        @click="addPromo"
      >
        Добавить промокод
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        v-b-modal.modal-promo
        variant="primary"
        class="mr-1 mt-1"
      >
        Загрузить из шаблона
      </b-button>
      <add-promos-templates-modal @select="onSelectTemplate" />
    </div>
  </div>
</template>

<script>
import { BFormInput, BButton, BFormCheckbox } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import PriceInputWrapper from '@/global-components/PriceInputWrapper.vue'
import AddPromosTemplatesModal from '../AddPromosTemplatesModal.vue'

export default {
  name: 'PromoCodesSection',

  components: {
    BFormInput,
    BButton,
    BFormCheckbox,
    flatPickr,
    PriceInputWrapper,
    AddPromosTemplatesModal,
  },

  directives: {
    Ripple,
  },

  props: {
    promoCodes: { type: Array, required: true },
  },

  data() {
    return {
      dateConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
      },
    }
  },

  computed: {
    localPromoCodes: {
      get() {
        return this.promoCodes
      },
      set(val) {
        this.$emit('update:promoCodes', val)
      },
    },
  },

  watch: {
    promoCodes: {
      handler(promos) {
        this.normalizePromos(promos)
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    addPromo() {
      this.localPromoCodes = [
        ...this.localPromoCodes,
        {
          code: null,
          value: null,
          percent: true,
          expiresAt: null,
          usageLimitInitial: null,
        },
      ]
    },

    normalizePromos(promos) {
      if (!Array.isArray(promos)) return

      promos.forEach(promo => {
        if (promo.percent === undefined) {
          this.$set(promo, 'percent', true)
        }

        if (promo.expiresAt === undefined) {
          this.$set(promo, 'expiresAt', null)
        }
      })
    },

    changeDiscountType(promo, isRubles) {
      this.$set(promo, 'percent', !isRubles)
      this.$set(promo, 'value', null)
    },

    removePromo(promo, index) {
      this.$emit('delete-promocode', promo, index)
    },

    onSelectTemplate(promos) {
      this.$emit('add-from-template', promos)
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.promo__items {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.promo__item {
  position: relative;
  margin: 0 15px 10px 15px;
  display: flex;
  flex-direction: column;
  max-width: max-content;
  box-shadow: 0 0 23px -2px rgba(34, 60, 80, 0.2);
  border-radius: 20px;
  padding: 25px;

  &-del {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    transition: 0.3s;
    color: #6e6b7b;
    &:hover {
      transform: scale(1.2);
    }
  }
}
</style>
